import { Injectable, Optional, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BASE_URL } from '@teamfoster/sdk/ssr';

@Injectable({
  providedIn: 'root',
})
export class KlaviyoService {
  constructor(
    private http: HttpClient,
    @Optional()
    @Inject(BASE_URL)
    private BASE_URL: string
  ) {}

  subscribeBackInStock(email: string, productId: string) {
    return this.http.get<boolean>(`${this.BASE_URL}api/klaviyo/subscribe?userEmail=${email}&productId=${productId}`);
  }

  getKlaviyoSubscribedProducts(email: string) {
    return this.http.get<string[]>(`${this.BASE_URL}api/klaviyo/profile-subscriptions?userEmail=${email}`);
  }
}
